<script lang="ts" setup>
const appUserDataStore = useAppUserData();
const {
  hasClassroomMode,
  hasLMSConfig,
  hasInitializedUserLMSConfig,
  showOtherUsersClassrooms,
  appUser,
} = storeToRefs(appUserDataStore);

const showClassroomSideBar = computed(() => {
  if (hasInitializedUserLMSConfig.value == false) return false;

  return hasClassroomMode.value == true || hasLMSConfig.value == true;
});

const userClassroomDataStore = useUserClassroomsDataStore();
const {
  visibleClassrooms,
  userClassrooms,
  hasOtherUserClassrooms,
  otherUserClassrooms,
} = storeToRefs(userClassroomDataStore);

const onUpdateShowOtherUsersClassrooms = async (value: boolean) => {
  if (appUser.value == undefined) return;

  appUser.value.showOtherUsersClassrooms = value;

  await appUserDataStore.saveUser();
};
</script>

<template>
  <div v-auto-animate class="flex flex-row h-full">
    <div
      v-if="showClassroomSideBar"
      class="flex flex-col mb-4 items-center !w-[320px] h-full border-r-2 pr-4"
      data-step-id="classroom-sidebar"
    >
      <div
        class="flex flex-row items-center border-b w-full justify-between mb-2 py-2"
      >
        <label class="text-h6"> Classrooms </label>
        <VDropdown>
          <BaseIconButton :size="35" data-step-id="classroom-popover-button">
            <icon name="material-symbols:more-vert" size="35" />
          </BaseIconButton>
          <template #popper>
            <div class="flex flex-col bg-surface z-50">
              <NuxtLink
                to="/configure/lms/classrooms"
                data-step-id="configure-classrooms-button"
              >
                <BaseTextButton> Manage Classrooms </BaseTextButton>
              </NuxtLink>
              <div
                v-if="hasOtherUserClassrooms"
                class="flex flex-row items-center gap-2 px-4 py-2 mb-2"
              >
                <span> Show other teachers' classrooms? </span>
                <BaseToggle
                  :model-value="showOtherUsersClassrooms"
                  @update:model-value="onUpdateShowOtherUsersClassrooms"
                />
              </div>
            </div>
          </template>
        </VDropdown>
      </div>
      <div class="flex flex-col grow min-h-0 overflow-auto w-full">
        <ClassroomFoldersList v-if="hasLMSConfig" />
        <div v-if="hasLMSConfig != true">
          <p class="my-4 text-center">
            Would you like to set up your classrooms?
          </p>
          <NuxtLink to="/configure/lms/choose">
            <BaseButton> Set Up Classrooms </BaseButton>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
